var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":_vm.img,"alt":""}})]),_c('div',{staticClass:"text-wrap"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"btn",on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.btnText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }